import { queryClient } from "src/App";

import { RQ_STATION_DETAILS_KEY } from "../hooks/useStationDetails";
import { WssStationEventTypes, WssStationPayload } from "../types/Wss";
import { StationModel } from "../types/Station";
import { RQ_STATION_CONFIGURATION_KEY } from "../hooks/useStationConfiguration";
import { RQ_STATION_LIST_KEY } from "../hooks/useStationList";

export const resolveWssStationEvent = (wssPayload: WssStationPayload) => {
    const stationData = queryClient.getQueryData([
        RQ_STATION_DETAILS_KEY,
        wssPayload.stationId,
    ]) as StationModel;
    if (stationData) {
        switch (wssPayload.event) {
            case WssStationEventTypes.STATION_STATUS:
                queryClient.setQueryData([RQ_STATION_DETAILS_KEY, wssPayload.stationId], {
                    ...stationData,
                    status: wssPayload.status,
                });
                break;
            case WssStationEventTypes.STATION_CONFIG_CHANGE:
                // queryClient.setQueryData([RQ_STATION_DETAILS_KEY, wssPayload.stationId], {
                //     ...stationData,
                //     status: StationConfigurationStatus.REBOOT_REQUIRED
                //         ? "reboot-required"
                //         : stationData?.status,
                // });
                // -> usunięte specjalnie, status reboot powinna zwrocic stacja, nie ustawiamy tego ręcznie
                break;
            case WssStationEventTypes.STATION_AVAILABILITY:
                break;
            case WssStationEventTypes.STATION_CONFIG_REFRESH:
                queryClient.refetchQueries([[RQ_STATION_CONFIGURATION_KEY, stationData.id]]);
                break;
            case WssStationEventTypes.STATION_RESET:
                break;
            case WssStationEventTypes.EVSE_STATUS:
                queryClient.setQueryData([RQ_STATION_DETAILS_KEY, wssPayload.stationId], {
                    ...stationData,
                    evses: [
                        ...stationData.evses.map((evse) => {
                            if (evse.connectorId === wssPayload.connectorId) {
                                return { ...evse, status: wssPayload.status };
                            }
                            return { ...evse };
                        }),
                    ],
                });
                break;
            case WssStationEventTypes.EVSE_AVAILABILITY:
                break;
            case WssStationEventTypes.EVSE_NOT_FOUND:
                break;
            default:
                break;
        }
    }
    const stationList = queryClient.getQueriesData({ queryKey: [RQ_STATION_LIST_KEY] });
    if (stationList?.length > 0) {
        stationList.forEach((sl) => {
            const page = sl[1] as any;
            const pageData = page?.data;
            const newPageData = pageData.map((pd: any) => {
                if (pd.id === wssPayload.stationId) {
                    switch (wssPayload.event) {
                        case WssStationEventTypes.STATION_STATUS:
                            return { ...pd, status: wssPayload.status };
                        case WssStationEventTypes.EVSE_STATUS:
                            return {
                                ...pd,
                                evses: [
                                    ...pd.evses.map((evse: any) => {
                                        if (
                                            evse.connectorId ===
                                            parseInt(`${wssPayload.connectorId}`)
                                        ) {
                                            return { ...evse, status: wssPayload.status };
                                        }
                                        return { ...evse };
                                    }),
                                ],
                            };
                    }
                }
                return { ...pd };
            });
            queryClient.setQueryData(sl[0], {
                count: page.count,
                data: newPageData,
                nextPage: page.nextPage,
            });
        });
    }
};
